var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.5H16V10.5H8V12.5ZM8 8.5H16V6.5H8V8.5ZM19.95 20.975L15.9 15.7C15.6167 15.3167 15.2667 15.0208 14.85 14.8125C14.4333 14.6042 13.9833 14.5 13.5 14.5H4V4.5C4 3.95 4.19583 3.47917 4.5875 3.0875C4.97917 2.69583 5.45 2.5 6 2.5H18C18.55 2.5 19.0208 2.69583 19.4125 3.0875C19.8042 3.47917 20 3.95 20 4.5V20.5C20 20.5833 19.9958 20.6625 19.9875 20.7375C19.9792 20.8125 19.9667 20.8917 19.95 20.975ZM6 22.5C5.45 22.5 4.97917 22.3042 4.5875 21.9125C4.19583 21.5208 4 21.05 4 20.5V16.5H13.5C13.6667 16.5 13.8208 16.5375 13.9625 16.6125C14.1042 16.6875 14.225 16.7917 14.325 16.925L18.525 22.425C18.4417 22.4583 18.3542 22.4792 18.2625 22.4875C18.1708 22.4958 18.0833 22.5 18 22.5H6Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.4104227ff6daea3b6a8ad84cded053b9.svg";
export { ForwardRef as ReactComponent };